import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import toast from "./toastInstance";
import { getGlobalI18n } from "@/contexts/I18nContext";
import { getTargetUrl } from "@/utils";

// 错误处理方案： 错误类型
export enum ErrorShowType {
  SILENT = 20000, //会话过期，此时客户端需要重新初始化
  WARN_MESSAGE = 20001, //客户端未初始化，此时客户端需要重新初始化
  ERROR_MESSAGE = 20002, //系统处理JSON出错
  NOTIFICATION = 20003, //未找到智能体
  FAILEDTOWRITEINFORMATION = 20004, //写入聊天信息失败
  FAILEDTOUPDATECHATHISTORY = 20005, //更新聊天记录失败
  NOCHATHISTORYFOUND = 20006, //未找到聊天记录
  FAILEDTOUPDATECHARSESSION = 20007, //更新聊天会话失败
  INVALIDAGENTPLATFORM = 20008, //无效的智能体平台
  ERROR = 20009, //服务器错误
  CALLPAINTFREQUENTLY = 20010, //调用对话接口频繁
  USERIPCHANGES = 20011, //用户IP改变，此时客户端需要重新初始化
  TOOMANYCONVERSATIONS = 20012, //对话次数太多，已达上限
  WEBSOCKETAUTHENTICATIONFAILED = 1008, //websocket认证失败，有可能是状态过期导致
  WEBSOCKETCONNECTTIONTIMEDOUT = 1001, //websocket心跳检测连接超时，可能网络导致连
  WEBSOCKETQUERYPARAMETERS = 1007, //ebsocket查询参数缺失
  NOAGENTFOUND = 4000, //未找到智能体
}

//获取当前接口地址
// const baseUrl =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_BASE_URL
//     : "https://ai-agent-test-api.afirstsoft.cn";
const baseUrl = getTargetUrl();

// 创建自定义实例
const service: AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 40000, //设置40秒超时
  withCredentials: true, //允许传递cookie
});

// 全局网络状态管理
export let isNetworkAvailable = navigator.onLine;

// 监听网络状态变化
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    isNetworkAvailable = true;
    toast.dismiss("network-error");
  });

  window.addEventListener("offline", () => {
    isNetworkAvailable = false;
    const i18n = getGlobalI18n();
    toast.error(i18n.formatMessage("networkAnomalyText"));
  });
}

// 请求拦截器
service.interceptors.request.use(
  (config: any) => {
    // 在请求前检查网络状态
    if (!isNetworkAvailable) {
      const i18n = getGlobalI18n();
      toast.error(i18n.formatMessage("networkAnomalyText"));
      return Promise.reject(i18n.formatMessage("networkAnomalyText"));
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const res: any = response.data;
    // code === 0标识成功，不是流数据才显示错误信息, 其他标识失败
    if (res.code !== 0) {
      toast.error(res?.err_msg);
      return Promise.reject(res.err_msg || "请求错误");
    }
    return res;
  },
  (error: AxiosError) => {
    const i18n = getGlobalI18n();
    // 请求已发出但没有收到响应
    if (error?.request) {
      toast.error(i18n.formatMessage("networkAnomalyText"));
    }
    return Promise.reject(error);
  }
);

export default service;
